module.exports = __webpack_public_path__ + "img/17.a435ed6b.jpg";